export default { sha: '0c176c474446aa25c6c5bf1861db83347f07ea94', buildNumber: 'undefined' }
